import { LitElement, html, css, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '../../store/store.js';
import { load, loadPreview } from '../../store/composition/composition.js';
import { notifyDone } from '../../store/notify/notify.js';
import { applyStyles } from '../../helpers/stylesheets.js';
import '@polymer/paper-toast/paper-toast.js';
import '../composition/sdb-composition-item.js';
import '../composition/sdb-composition-compound-item.js';
import '../composition/sdb-composition-compound-test-item.js';
import '../composition/sdb-composition-status.js';
import '../shared/sdb-player-overlay-element.js';

@customElement('sdb-composition-player')
class SdbCompositionPlayer extends connect(store)(LitElement)
 {

    @property({ type: String })
    accessor compositionId;

    @property({ type: String })
    accessor sessionId;

    @property({ type: String })
    accessor type;

    @property({ type: Boolean })
    accessor preview;

    @property({ type: Boolean })
    accessor hideCompositionStatus;

    @property({ type: Boolean })
    accessor browse;

    @state()
    accessor composition;

    @state()
    accessor isLoading;

    @state()
    accessor message;

    set message(val) {
        if (val) {
            this._showMessage(val);
        }
    }

    get toast() {
        return document.getElementById('player_toast');
    }

    stateChanged(state) {
        this.composition = state.composition.data;
        this.isLoading = state.composition.status === 'loading' || !state.composition.data;
        this.message = state.notify.text;
    }

    static get playerStyles() {
        return css`
            paper-toast.player-toast {
                text-align: center;
                z-index: 3000;
            }
        `;
    }

    static get styles() {
        return css`
            .player {
                max-width: 1100px;
                margin-top: 20px;
                margin-left: auto;
                margin-right: auto;
                line-height: normal;
            }

            .composition-status {
                display: flex;
            }

            sdb-composition-status {
                width: 100%;
            }

            .composition-content {
                display: flex;
                flex-flow: row wrap;
            }
        `;
    }

    render() {
        if (!this.composition) {
            return html`<div></div>`;
        }

        return html`
            <div class="player">
                <div class="composition-status">
                    ${!this.preview && !this.hideCompositionStatus ? html`
                        <sdb-composition-status
                            .composition=${this.composition}
                            noSettings="hideAll"
                            small>
                        </sdb-composition-status>
                    ` : nothing}
                </div>
                <div class="composition-content">
                    ${this.composition.items.map(this._renderItem)}
                </div>
            </div>
            <sdb-player-overlay-element>
                <paper-toast
                    id="player_toast"
                    class="player-toast">
                </paper-toast>
            </sdb-player-overlay-element>
        `;
    }

    firstUpdated() {
        applyStyles(SdbCompositionPlayer.playerStyles);

        if (this.preview) {
            store.dispatch(loadPreview({
                compositionId: this.compositionId,
                type: this.type,
            }));
            return;
        }
        store.dispatch(load({
            compositionId: this.compositionId,
            sessionId: this.sessionId,
        }));
    }

    _renderItem(item) {
        switch (item.type) {
            case 'compound':
                return html`<sdb-composition-compound-item .item=${item}></sdb-composition-compound-item>`;
            case 'compound-test':
                return html`<sdb-composition-compound-test-item .item=${item}></sdb-composition-compound-test-item>`;
            default:
                return html`<sdb-composition-item .item=${item}></sdb-composition-item>`;
        }
    }

    _showMessage(text) {
        if (!this.toast)
            return;

        this.toast.text = text;
        this.toast.show();
        store.dispatch(notifyDone())
    }
}
